import Body from './modal.body';
import Header from './modal.header';
import Footer from './modal.footer';
import Modal from './modal.component';

export default {
  Root: Modal,
  Header,
  Body,
  Footer,
};
